const heroScrollLink = document.querySelector('.hero-scroll');
const foundersTarget = document.querySelector('#founders');

if (heroScrollLink && foundersTarget) {
    heroScrollLink.addEventListener('click', function(e) {
        e.preventDefault();

        const prefersReducedMotion =
            typeof window !== 'undefined' &&
            'matchMedia' in window &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        foundersTarget.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });
}
